var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"p-4 animated fadeIn",attrs:{"variant":"dark","to":_vm.item.url,"block":""}},[_c('i',{class:`fal ${_vm.item.icon} font-5xl`}),_c('div',{staticClass:"pt-3 font-weight-bold text-uppercase"},[_c('span',[_vm._v(_vm._s(_vm.item.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }